import { useEffect } from 'react';
import { getGoogleFontsUrl, AVAILABLE_FONTS } from '@/utils/fonts';

interface FontLoaderProps {
  fontFamily?: string;
}

export function FontLoader({ fontFamily }: FontLoaderProps) {
  useEffect(() => {
    if (!fontFamily || fontFamily === 'inherit') return;

    // Check if it's a Google Font
    const fontOption = AVAILABLE_FONTS.find(f => f.value === fontFamily);
    if (fontOption?.type !== 'google') return;

    const linkId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;
    
    // Check if already loaded
    if (document.getElementById(linkId)) return;

    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = getGoogleFontsUrl([fontFamily]);
    
    document.head.appendChild(link);

    return () => {
      // Optional: remove font when component unmounts or font changes
      // Keeping it might be better for performance if user switches back
      // const existingLink = document.getElementById(linkId);
      // if (existingLink) {
      //   document.head.removeChild(existingLink);
      // }
    };
  }, [fontFamily]);

  return null;
}
